

















































import { Component } from 'vue-property-decorator';
import { mapActions } from 'vuex';
import ResetPasswordRequestForm from '@/components/reset-password/ResetPasswordRequestForm.vue';
import { ResetPasswordRequestFormData } from '@/model/ResetPassword';
import { mixins } from 'vue-class-component';
import ToastMixin from '@/mixins/ToastMixin';
import CustomModal from '@/components/modal/CustomModal.vue';
import CustomOverlay from '@/components/overlay/custom-overlay.vue';

@Component({
    components: {
        ResetPasswordRequestForm,
        CustomModal,
        CustomOverlay,
    },
    methods: {
        ...mapActions({
            resetPasswordRequest: 'resetPasswordStorage/resetPasswordRequest',
        }),
    },
})
export default class ResetPasswordRequest extends mixins(ToastMixin) {
    loading = false;

    resetPasswordRequest!: (
        formData: ResetPasswordRequestFormData,
    ) => Promise<void>;

    mounted(): void {
        this.$store.commit('resetPasswordStorage/setError', null);
    }

    onSubmit(formData: ResetPasswordRequestFormData): void {
        this.loading = true;

        this.resetPasswordRequest(formData).finally(() => {
            this.loading = false;
            this.$bvModal.hide('reset-password-request-modal');
            this.$bvModal.show('reset-password-request-modal-confirm');
        });
    }

    closeSuccessModal(): void {
        this.$bvModal.hide('reset-password-request-modal-confirm');
    }
}
